import { render, staticRenderFns } from "./EditTrainConfiguration.vue?vue&type=template&id=2dbf0ad8&scoped=true"
import script from "./EditTrainConfiguration.vue?vue&type=script&lang=js"
export * from "./EditTrainConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf0ad8",
  null
  
)

export default component.exports